<app-base-action-modal
  modalTitle="Review Account Values"
  i18n-modalTitle
  primaryLabel="Continue with Specified Values"
  i18n-primaryLabel
  secondaryLabel="Edit Values"
  i18n-secondaryLabel
  (primaryClicked)="continueWithSpecifiedValues()"
  (secondaryClicked)="editValues()"
  (closeClicked)="editValues()">
  <div class="d-flex flex-column gap-4">
    <div *ngFor="let jurisdiction of jurisdictions" class="d-flex flex-column gap-3">
      <div class="d-flex flex-column gap-2">
        <span class="label-md">{{ jurisdiction.jurisdictionName }}</span>
        <div class="paragraph-lg secondary" i18n>
          The monthly payment amount that was entered will fall short of the annual minimum. If the annual minimum is
          not reached by year-end, the difference will be paid out to the member.
        </div>
      </div>
      <div class="d-flex flex-column gap-3">
        <div class="info-card d-flex flex-column gap-2">
          <span class="label-md" i18n>Annual Minimum</span>
          <span class="paragraph-lg">{{ jurisdiction.minAnnualAmount | currency }}</span>
        </div>
        <div class="info-card d-flex flex-column gap-2">
          <span class="label-md" i18n>Est. Annual Total</span>
          <span class="paragraph-lg">{{ jurisdiction.estimatedAnnualTotal | currency }}</span>
        </div>
      </div>
    </div>
  </div>
</app-base-action-modal>
